export default __webpack_public_path__ + "static/media/Mask Group 137.54a7ff01.svg";